import callNativeMethod from './callNativeMethod';
import NATIVEFUNCTION_TYPE from './nativeFunctionType';
import myInterface from './myInterface';

/**
 * @param {*} statusCode
 * @param {*} responseTime
 * @param {*} responseSize
 * @param {string} json
 * @return {*}
 */
const sendEventsToHawkeye = (statusCode, responseTime, responseSize, json) => {
  const methodBody = {
    functionName: NATIVEFUNCTION_TYPE.sendEventsToHawkeye,
    parameters: {
      argument1: statusCode,
      argument2: responseTime,
      argument3: responseSize,
      argument4: json,
    },
  };
  try {
    callNativeMethod(methodBody);
    return true;
  } catch (error) {
    console.log('inside sendEventsToHawkeye');
    if (myInterface.sendEventsToHawkeye) {
      console.log(statusCode, responseTime, responseSize, json);
      return myInterface.sendEventsToHawkeye(
        statusCode,
        responseTime,
        responseSize,
        json,
      );
    }
    return () => undefined;
  }
};

export default sendEventsToHawkeye;
